import { toTrackId } from "../../analytics/trackIds";
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { SessionContext } from "../../context/SessionContext";
import { getSettingsCopy, getSettingsItems } from "../settings/SettingsFrame";
import CinemaIcon from "../cinema/CinemaIcon";
export default function TivibuSettings() {
  const { setPath } = useContext(SessionContext),
    copy = getSettingsCopy(),
    items = getSettingsItems();
  useEffect(() => {
    setPath("/dashboard/settings");
  }, [setPath]);
  return (
    <div className="settings-overview">
      {copy.groups.map((group, index) => (
        <section key={group} className="settings-card-section">
          <h2>
            <span>0{index + 1}</span>
            {group}
          </h2>
          <div className="settings-card-grid">
            {items
              .filter((item) => item.group === index)
              .map((item) => (
                <Link
                  data-track-id={toTrackId("settings", item.id)}
                  className="settings-destination"
                  key={item.id}
                  to={item.path}
                >
                  <span className="settings-destination-icon">
                    <CinemaIcon name={item.icon} />
                  </span>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.note}</p>
                  </div>
                  <CinemaIcon name="arrow" />
                </Link>
              ))}
          </div>
        </section>
      ))}
    </div>
  );
}
